/**
 * Enregistrement des notifications push NATIVES (app Capacitor iOS/Android).
 *
 * Ce script s'exécute sur le site, mais ne fait quelque chose QUE lorsqu'il
 * tourne à l'intérieur de l'app native Capacitor (via le plugin
 * @capacitor-firebase/messaging). Sur le web/PWA classique, il ne fait rien
 * (c'est le Web Push habituel qui prend le relais).
 *
 * Flux : demander la permission → récupérer le token FCM → l'envoyer au
 * backend (/native-push-tokens) pour que PushNotificationService puisse pousser.
 */
(function () {
    'use strict';

    // Tourne-t-on dans l'app native ?
    function isNative() {
        return !!(window.Capacitor && typeof window.Capacitor.isNativePlatform === 'function' && window.Capacitor.isNativePlatform());
    }

    function platform() {
        try {
            return window.Capacitor.getPlatform(); // 'ios' | 'android'
        } catch (e) {
            return null;
        }
    }

    function csrfToken() {
        const el = document.querySelector('meta[name="csrf-token"]');
        return el ? el.getAttribute('content') : null;
    }

    // Envoie le token au backend.
    async function saveToken(token) {
        if (!token) return;
        try {
            await fetch('/native-push-tokens', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken(),
                    Accept: 'application/json',
                },
                body: JSON.stringify({
                    token: token,
                    platform: platform(),
                    deviceInfo: JSON.stringify({ userAgent: navigator.userAgent }),
                }),
            });
            console.log('[NativePush] Token enregistré');
        } catch (e) {
            console.error('[NativePush] Échec enregistrement token', e);
        }
    }

    async function init() {
        if (!isNative()) return; // Web/PWA → rien à faire ici.

        const FM = window.Capacitor.Plugins && window.Capacitor.Plugins.FirebaseMessaging;
        if (!FM) {
            console.log('[NativePush] Plugin FirebaseMessaging absent');
            return;
        }

        try {
            const perm = await FM.requestPermissions();
            if (perm.receive !== 'granted') {
                console.log('[NativePush] Permission refusée');
                return;
            }

            // Token courant.
            const { token } = await FM.getToken();
            await saveToken(token);

            // Rafraîchissement du token (FCM peut le renouveler).
            FM.addListener('tokenReceived', (event) => {
                saveToken(event && event.token);
            });
        } catch (e) {
            console.error('[NativePush] Initialisation impossible', e);
        }
    }

    document.addEventListener('DOMContentLoaded', init);
})();
